var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchDarkblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons-action/Search/Darkblue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1,7.75 C1,4.028 4.028,1 7.75,1 C11.472,1 14.5,4.028 14.5,7.75 C14.5,11.472 11.472,14.5 7.75,14.5 C4.028,14.5 1,11.472 1,7.75 M19.847,17.307 L14.334,11.819 C15.069,10.635 15.5,9.243 15.5,7.75 C15.5,3.477 12.024,0 7.75,0 C3.477,0 0,3.477 0,7.75 C0,12.023 3.477,15.5 7.75,15.5 C9.23,15.5 10.609,15.076 11.787,14.353 L17.294,19.836 C17.489,20.029 17.803,20.03 17.998,19.838 L19.845,18.017 C20.043,17.822 20.044,17.503 19.847,17.307",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-action/Search/Darkblue"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#003755",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDarkblue);
export default __webpack_public_path__ + "static/media/search_darkblue.c586a25114c818593a4f04689751a16b.svg";
export { ForwardRef as ReactComponent };